import './ShowSection.scss';

import { Card, Divider } from 'antd';
import { CardProps } from 'antd/lib';
import { ReactNode } from 'react';

interface ShowSectionProps extends CardProps {
  title?: ReactNode;
  children: ReactNode;
  withoutCard?: boolean;
  /** Elemento extra renderizado a la derecha del título (ej: botón Editar). */
  headerExtra?: ReactNode;
}
/**
 * Estandarización de secciones dentro de pantallas show para evitar repetir Card + título. Permite también opción sin Card para casos puntuales.
 * @param props.title Título de la sección.
 * @param props.children Contenido de la sección.
 * @param props.withoutCard Indica si la sección debe renderizarse sin Card (opcional, por defecto false).
 * @returns
 */
export const ShowSection = (props: ShowSectionProps) => {
  const { title, children, className, withoutCard, headerExtra, ...cardProps } = props;
  const header =
    title || headerExtra ? (
      <div className="ShowSectionHeader">
        {title && <div className="ShowSectionTitle">{title}</div>}
        {headerExtra && <div className="ShowSectionExtra">{headerExtra}</div>}
      </div>
    ) : null;

  if (withoutCard) {
    return (
      <div className={`ShowSection ${className || ''}`}>
        {header}
        {children}
      </div>
    );
  }

  return (
    <Card className={`ShowSection ${className || ''}`} {...cardProps}>
      {header}
      {children}
    </Card>
  );
};

// Subsecciones dentro de ShowSection para evitar repetir Divider + título.
interface ShowSubsectionProps {
  title: ReactNode;
  children: ReactNode;
}

/**
 * Estandarización de subsecciones dentro de ShowSection para evitar repetir Divider + título.
 * @param props.title Título de la subsección.
 * @param props.children Contenido de la subsección.
 * @returns
 */
export const ShowSubsection = (props: ShowSubsectionProps) => {
  const { title, children } = props;

  return (
    <div className="ShowSubsection">
      <Divider className="ShowSubsectionTitle" plain size="small">
        {title}
      </Divider>
      {children}
    </div>
  );
};
